import { ProjectStatus } from "../enums/project-status";
import { AllowedActionsMap, StateMachine, TransitionMap } from "./state-machine";

export type ProjectAction = 
  'Start' 
| 'Complete'
//UI Only
| 'Edit'
| 'ViewRefunds'
| 'ViewReports';

// --- EXACT MIRROR of EnsureValidTransition on the server ---
const transitions: TransitionMap<ProjectStatus> = {
  [ProjectStatus.Preparation]: [ProjectStatus.Started, ProjectStatus.Completed],
  [ProjectStatus.Started]:     [ProjectStatus.Completed],
  // Completed is terminal
};

// --- EXACT MIRROR of EnsureValidAction on the server ---
const allowedActions: AllowedActionsMap<ProjectStatus, ProjectAction> = {
  [ProjectStatus.Preparation]: ['Edit', 'Start', 'Complete'],
  [ProjectStatus.Started]:     ['ViewReports', 'Complete'],
  [ProjectStatus.Completed]:   ['ViewRefunds'],
};

export const ProjectStateMachine = new StateMachine<ProjectStatus, ProjectAction>({
  transitions,
  allowedActions,
});
